import queryString from "query-string";

import { POTENTIAL_TABS } from "./constants";

// Màn Danh sách khách hàng render nội dung bằng `contentList[activeTabKey]`, nên một giá trị
// `statuses` không khớp tab nào sẽ khiến không tab nào được render — kéo theo Drawer chi tiết
// (nằm bên trong tab) cũng không mở. Chỉ 4 status dưới đây có tab; APPROVED_SELLER thì không.
const TAB_STATUSES = [
  POTENTIAL_TABS.NEW,
  POTENTIAL_TABS.TAKING_CARE,
  POTENTIAL_TABS.STOP_CARING,
  POTENTIAL_TABS.COMPLETED,
];

// Khách đã chăm sóc xong nằm ở tab "Chờ duyệt" của màn Danh sách tài khoản đại lý — cùng dữ liệu
// với tab "Hoàn thành" bên màn Danh sách khách hàng (cùng query, cùng filter statuses), nhưng
// Drawer ở đó nhận `isAgent` nên có thêm nút Duyệt / Từ chối.
export const isWaitingSellerApproval = (potentialCustomer) => potentialCustomer?.status === POTENTIAL_TABS.COMPLETED;

// Build URL sang màn danh sách chứa khách hàng này, lọc sẵn đúng họ và mở Drawer chi tiết.
// Trả về `undefined` khi không có `id` — nơi gọi dùng để quyết định có render link hay không.
export const buildCustomerListUrl = (potentialCustomer) => {
  if (!potentialCustomer?.id) return undefined;

  const query = queryString.stringify(
    {
      // Status ngoài whitelist thì rơi về tab NEW: bảng có thể không chứa khách hàng đó,
      // nhưng tab vẫn render nên Drawer vẫn mở đúng người.
      statuses: TAB_STATUSES.includes(potentialCustomer?.status) ? potentialCustomer?.status : POTENTIAL_TABS.NEW,
      customerIDs: [potentialCustomer?.id],
      defaultID: potentialCustomer?.id,
    },
    { arrayFormat: "index" }
  );

  // Cả hai màn đều dựng tab bằng `?statuses` và dùng chung `usePotentialCustomerList`,
  // nên `customerIDs` + `defaultID` hoạt động y hệt nhau ở hai nơi.
  return `${isWaitingSellerApproval(potentialCustomer) ? "/seller" : "/potential-customer-list"}?${query}`;
};

// Dự phòng khi đơn không có `potentialCustomer` (BE chưa join, dù bản ghi khách hàng vẫn tồn tại và
// trỏ đúng `sellerID`): không có ID để lọc chính xác nên tìm theo SĐT rồi email — chấp nhận ra vài
// dòng trùng và người dùng tự mở chi tiết. Không dùng fullName vì trùng nhiều hơn hẳn.
export const buildSellerApprovalSearchUrl = (seller) => {
  const searchTerm = seller?.telephone || seller?.email;
  if (!searchTerm) return undefined;

  // Cố định tab Chờ duyệt: nút Duyệt chỉ hiện ở status COMPLETE_CARING nên một seller đang chờ
  // duyệt gần như chắc chắn nằm ở đó — không có `potentialCustomer.status` để biết chính xác.
  return `/seller?${queryString.stringify({ statuses: POTENTIAL_TABS.COMPLETED, query: searchTerm })}`;
};
